import React from 'react';
import { withRouter } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';

import Nav from 'react-bootstrap/lib/Nav';
import Navbar from 'react-bootstrap/lib/Navbar';
import NavItem from 'react-bootstrap/lib/NavItem';

import classnames from 'classnames';
import smoothscroll from 'smoothscroll-polyfill';
import { connect } from 'react-redux';
import { setAuthStatus, setLandingScrollPosition } from '../redux/actionCreators';
import Api from '../api/api';

smoothscroll.polyfill();

class Header extends React.Component {
  state = {
    expanded: false,
  };

  componentDidMount = () => {
    if (this.props.authenticated) {
      return Api.users.getUserPersonalData().catch(error => {
        if (error.response.status === 401) {
          this.props.handleChangeAuthStatus(false);
          localStorage.removeItem('token');
          localStorage.removeItem('userName');
        }
      });
    }
  };

  handleLogout = () => {
    Api.users.logout().then(() => {
      this.props.handleChangeAuthStatus(false);
      this.handleNavLinkClick();
    });
  };

  collapseNavbar = () => {
    const { expanded } = this.state;
    expanded && this.setState({ expanded: false });
  };

  toggleNavbar = () => this.setState({ expanded: !this.state.expanded });

  handleNavLinkClick = () => {
    this.collapseNavbar();
    this.props.handleLandingScrollPositionUpdate('');
  };

  render() {
    const { expanded } = this.state;

    return (
      <Navbar
        fluid
        expanded={expanded}
        onToggle={this.toggleNavbar}
        fixedTop
        className={classnames({ register: this.props.location.pathname === '/register' })}
      >
        <Navbar.Header>
          <Link
            scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            to="/#greeting"
            onClick={this.collapseNavbar}
          >
            <Navbar.Brand className="meet-litpog" />
          </Link>
          <Navbar.Toggle onClick={this.toggleNavbar} />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav className="top-link">
            <li
              role="presentation"
              className={this.props.landingScrollPosition === 'about' ? 'active' : null}
              onClick={this.collapseNavbar}
            >
              <Link
                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                to="/#about"
                className="first-top-link transition-link"
              >
                {/*<span className="wobble-vertical">About</span>*/}
                <span className="transition-link-span">About</span>
              </Link>
            </li>

            <li
              role="presentation"
              className={this.props.landingScrollPosition === 'features' ? 'active' : null}
              onClick={this.collapseNavbar}
            >
              <Link
                className="transition-link"
                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                to="/#features"
              >
                {/*<span className="wobble-vertical">Key Features</span>*/}
                <span className="transition-link-span">Key Features</span>
              </Link>
            </li>

            <li
              role="presentation"
              className={this.props.landingScrollPosition === 'mobile-app' ? 'active' : null}
              onClick={this.collapseNavbar}
            >
              <Link
                className="transition-link"
                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                to="/#mobile-app"
              >
                {/*<span className="wobble-vertical">Mobile App</span>*/}
                <span className="transition-link-span">Mobile App</span>
              </Link>
            </li>

            <li
              role="presentation"
              className={this.props.landingScrollPosition === 'subscription-plans' ? 'active' : null}
              onClick={this.collapseNavbar}
            >
              <Link
                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                to="/#subscription-plans"
                id="subscription-plans-link"
                className="transition-link"
              >
                {/*<span className="wobble-vertical">Subscription Details</span>*/}
                <span className="transition-link-span">Subscription Details</span>
              </Link>
            </li>

            <li
              role="presentation"
              className={this.props.landingScrollPosition === 'book' ? 'active' : null}
              onClick={this.collapseNavbar}
            >
              <Link
                className="transition-link"
                scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                to="/#book"
              >
                {/*<span className="wobble-vertical">The Book</span>*/}
                <span className="transition-link-span">The Book</span>
              </Link>
            </li>

            <LinkContainer className="transition-link" to="/support" onClick={this.handleNavLinkClick}>
              <NavItem>
                {/*<span className="wobble-vertical">Support</span>*/}
                <span className="transition-link-span">Support</span>
              </NavItem>
            </LinkContainer>
          </Nav>
          <Nav pullRight className="top-link">
            {this.props.authenticated &&
              this.props.userName && (
                <LinkContainer to="/profile" onClick={this.handleNavLinkClick}>
                  <NavItem>
                    <span className="user-i">
                      <span className="user-log" />
                      {this.props.userName}
                    </span>
                  </NavItem>
                </LinkContainer>
              )}

            {!this.props.authenticated ? (
              <LinkContainer to="/login" onClick={this.handleNavLinkClick}>
                <NavItem>
                  <span>Login</span>
                </NavItem>
              </LinkContainer>
            ) : (
              <LinkContainer to="/login" onClick={this.handleLogout}>
                <NavItem className="logout-main">
                  <span className="logout-device" />
                </NavItem>
              </LinkContainer>
            )}

            {!this.props.authenticated && (
              <LinkContainer className="started-top-link" to="/register">
                <NavItem>
                  <span>Get Started</span>
                </NavItem>
              </LinkContainer>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  userName: state.session.userName,
  landingScrollPosition: state.landingScrollPosition,
});

const mapDispatchToProps = (dispatch: Function) => ({
  handleChangeAuthStatus(authenticated) {
    dispatch(setAuthStatus(authenticated));
  },

  handleLandingScrollPositionUpdate(landingScrollPosition) {
    dispatch(setLandingScrollPosition(landingScrollPosition));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js